import * as React from 'react';
import { flow } from 'lodash';
import { II18nMessages } from '../../../../../../services/branding/models';
import { reduxForm } from 'redux-form';
import { FaInfoCircle } from 'react-icons/fa';
import { Button, Modal as BootstrapModal } from 'react-bootstrap';
import { IBenefit } from '../../../../../../data/api/models';

const ModalHeader = BootstrapModal.Header;
const ModalTitle = BootstrapModal.Title;
const ModalBody = BootstrapModal.Body;
const ModalFooter = BootstrapModal.Footer;

interface IBenefitsModal {
  i18n: II18nMessages;
  tripType: string;
  level: string;
  benefits: IBenefit[];
}

interface IMyStates {
  showModal: boolean;
}

class BenefitsModal extends React.Component<IBenefitsModal, IMyStates> {
  public state = {
    showModal: false,
  };

  public openModal = () => {
    this.setState({
      showModal: true,
    });
  }

  public closeModal = () => {
    this.setState({
      showModal: false,
    });
  }

  private renderBenefit = (benefit: IBenefit) => {
    return (
      <tr key={benefit.name}>
        <td>{benefit.name}</td>
        <td>{benefit.text}</td>
        <td>{benefit.excess}</td>
      </tr>
    );
  }

  public render() {
    const { i18n, benefits } = this.props;

    return (
      <div>
        <div className="info-btn" onClick={this.openModal}>
          <FaInfoCircle />
        </div>

        <BootstrapModal show={this.state.showModal} onHide={this.closeModal} bsSize="large" >
          <ModalHeader closeButton={true}>
            <ModalTitle>Full Benefits</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <table>
              <thead>
              <tr>
                <td>{i18n.quote.schemeChoice.modal.benefit}</td>
                <td>{i18n.quote.schemeChoice.modal.maxSum}</td>
                <td>{i18n.quote.schemeChoice.modal.excess}</td>
              </tr>
              </thead>
              <tbody>
                {benefits.map(this.renderBenefit)}
              </tbody>
            </table>
          </ModalBody>
          <ModalFooter>
            <Button bsStyle="primary" onClick={this.closeModal}>
              {/*{i18n.quote.button.back}*/} Close
            </Button>
          </ModalFooter>
        </BootstrapModal>
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: 'scheme-choice',
  }),
])(BenefitsModal);
